import React, { useState, useEffect } from "react";
import { Box, Button, TextField } from "@material-ui/core";

export default function SearchField({
	searchString,
	setSearchString,
	onSearch,
  subject,
  isFullWidth = true
}) {
  const capitalizedSubject = subject[0].toUpperCase() + subject.slice(1);
  const [localSearchString, setLocalSearchString] = useState("");

  useEffect(() => setLocalSearchString(searchString), []);

  return (
    <Box
      width={isFullWidth ? "100%" : "30%"}
      component="span"
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
    >
      <Box display="flex">
        <TextField
          id="outlined-error"
          label={`Search ${capitalizedSubject}`}
          variant="outlined"
          margin="dense"
          value={localSearchString}
          onChange={(e) => {
            setLocalSearchString(e.target.value);
          }}
        />
      </Box>
      <Box display="flex">
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            setSearchString(localSearchString);
            onSearch(localSearchString);
          }}
        >
          Search
        </Button>
      </Box>
    </Box>
  );
}